import PlaySound from "./play_sound";
import { PLAYER_TYPE } from './player_type';
export default class Sentence extends PlaySound {
    isShow = false; //標記是否被朗讀到(高亮)
    constructor(el, target) {
        super(el, target);
        this.turn = el.turn;
        this.add_mouse_event();
        
        this.playerType = PLAYER_TYPE.SIMPLE;
    }

    init() {
        // super.init(target);
        this.normalFrame = 1;
        this.target.gotoAndStop(this.normalFrame);
        // console.log("go to", this.target);
    }

    trigger(needRemove = true) {
        super.trigger(needRemove);
        // console.log('do something(sentence)');
    }

    sentence_gotoAndStop(index) {
        // console.log(this.target);
        this.target.gotoAndStop(index);
        this.itemControl.loader.singleAntialiasing(this.target);
        // this.target.play();
    }

    add_mouse_event() {
        this.target.mouseChildren = false;
        this.target.removeAllEventListeners();
        this.target.addEventListener("click", () => {
            this.trigger();
            this.target.gotoAndStop(0);
        });
        this.target.addEventListener("mouseover", () => {
            if (this.target.currentFrame == 0) return;
            this.target.gotoAndStop(0);
            this.itemControl.loader.singleAntialiasing(this.target);
        });
        this.target.addEventListener("mouseout", () => {
            if (this.isShow || this.isTrigger) return;
            this.target.gotoAndStop(this.normalFrame);
            this.itemControl.loader.singleAntialiasing(this.target);
        });
    }
}